import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import getDatabase from 'Common/DB';
import { getDatabaseName, getOnline } from 'State/selectors';
import {
  shuffleQueue,
  addToQueue,
  setCurrentProfile,
} from 'PointOfSale/modules/queue/state/actions';
import QueueContainerComponent from 'PointOfSale/modules/queue/component/QueueContainer';
import {
  setKeypadReadingLeft,
  setKeypadReadingRight,
} from 'PointOfSale/state/actions';
import * as Sounds from 'Common/Resources/Sounds';
import * as POSSelectors from 'PointOfSale/selectors';
import {
  QueuedDirectionEnum,
  INVALID_STUDENT,
  KEYPAD_KEYS,
} from 'PointOfSale/modules/common/constants';
import { isVisitingStudent, searchStudents } from 'PointOfSale/helpers/profile';

import 'PointOfSale/styles/components/queue.less';

class QueueContainer extends Component {
  leftKeys = [];
  rightKeys = [];

  componentDidMount() {
    window.addEventListener('keyup', this.onKeyup);
  }

  componentWillUnmount() {
    window.removeEventListener('keyup', this.onKeyup);
  }

  componentDidUpdate(prevProps) {
    const { queue, currentProfile, setCurrentProfile } = this.props;
    if (
      !currentProfile.profile.Id &&
      currentProfile.profile.FullName !== INVALID_STUDENT.FullName &&
      prevProps.queue.length === 0 &&
      queue.length === 1
    ) {
      const profile = queue[0];

      setCurrentProfile(profile);
    }
  }

  onQueueItemClick = (index) => {
    this.props.shuffleQueue(index);
  };

  allowStudent(student) {
    const { serveVisitingStudentsViaPinPad, siteIds } = this.props;
    const isVisitor = isVisitingStudent(student.SiteId, siteIds);

    if (isVisitor && !serveVisitingStudentsViaPinPad) {
      return false;
    }
    return true;
  }

  async addStudentIdToQueue(id, isRight) {
    const {
      databaseName,
      addToQueue,
      serveVisitingStudentsViaPinPad,
      isOnline,
    } = this.props;
    let allowStudent = false;
    if (id.length > 0) {
      const DB = await getDatabase(databaseName);
      //search student number first then serving number
      let foundStudent = await DB.Students.where({
        Id: id,
      }).first();
      if (!foundStudent) {
        foundStudent = await DB.Students.where({
          ServingNumber: id,
        }).first();
      }

      // only check for visiting students if this preference is on and is online
      if (serveVisitingStudentsViaPinPad && isOnline) {
        foundStudent = await searchStudents(id);
      }

      if (foundStudent) {
        allowStudent = this.allowStudent(foundStudent);
      }

      if (allowStudent) {
        addToQueue(
          foundStudent,
          isRight ? QueuedDirectionEnum.Right : QueuedDirectionEnum.Left
        );
      } else {
        // play invalid student sound
        Sounds.Error.play();
        //add an invalid student
        addToQueue(
          INVALID_STUDENT,
          isRight ? QueuedDirectionEnum.Right : QueuedDirectionEnum.Left
        );
      }
    }
  }

  setStudentIdFromKeys = (isRight) => {
    let enteredNumber = isRight
      ? this.rightKeys.join('')
      : this.leftKeys.join('');

    this.addStudentIdToQueue(enteredNumber, isRight);
  };

  processKey(key) {
    const {
      readingLeft,
      readingRight,
      setKeypadReadingLeft,
      setKeypadReadingRight,
    } = this.props;

    switch (key) {
      case KEYPAD_KEYS.LEFT:
        if (readingLeft) {
          setKeypadReadingLeft(false);
          this.setStudentIdFromKeys(false);
          this.leftKeys = [];
        } else {
          setKeypadReadingLeft(true);
        }
        break;

      case KEYPAD_KEYS.RIGHT:
        if (readingRight) {
          setKeypadReadingRight(false);
          this.setStudentIdFromKeys(true);
          this.rightKeys = [];
        } else {
          setKeypadReadingRight(true);
        }
        break;

      default:
        if (readingLeft) {
          this.leftKeys.push(key);
        }

        if (readingRight) {
          this.rightKeys.push(key);
        }
        break;
    }
  }

  onKeyup = (e) => {
    this.processKey(e.key);
  };

  render() {
    const { queue, currentProfile, match } = this.props;
    return (
      <QueueContainerComponent
        queue={queue}
        currentProfile={currentProfile}
        onQueueItemClick={this.onQueueItemClick}
        showDetails={!!match.params.Id}
      />
    );
  }
}

QueueContainer.propTypes = {
  queue: PropTypes.array,
  currentProfile: PropTypes.object,
};

const mapStateToProps = (state) => ({
  queue: POSSelectors.getQueue(state),
  currentProfile: POSSelectors.getCurrentProfile(state),
  sessions: POSSelectors.getSessions(state),
  activeSession: POSSelectors.getActiveSession(state),
  databaseName: getDatabaseName(state),
  readingLeft: POSSelectors.getKeypadReadingLeft(state),
  readingRight: POSSelectors.getKeypadReadingRight(state),
  selectedSite: POSSelectors.getSelectedSiteDetails(state),
  serveVisitingStudentsViaPinPad: POSSelectors.getServeVisitingStudentsViaPinPad(
    state
  ),
  siteIds: POSSelectors.getSiteIds(state),
  isOnline: getOnline(state),
});

const mapDispatchToProps = {
  shuffleQueue,
  addToQueue,
  setKeypadReadingLeft,
  setKeypadReadingRight,
  setCurrentProfile,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(QueueContainer)
);



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/queue/container/QueueContainer.js